/**
 * Created by rathompson on 5/2/22
 * File: ManageTags
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { useMemo } from 'react'
import { Button, SheetBody, useModal, Body, TruncateText } from '@panwds/react-ui'
import { Form, Checkbox, SubmitButton } from '@panwds/react-form'
import { DeleteIcon, PencilIcon } from '@panwds/icons'
import SearchInput from '../../../common/components/inputs/SearchInput'
import {
  BUTTON_ADD_TAG,
  BUTTON_CANCEL,
  BUTTON_SAVE,
  COLUMN_ASSOCIATED_APPS,
  COLUMN_TAGS, LABEL_NONE,
} from '../../constants/LabelConstants'
import NewTagModal from '../modal/NewTagModal'
import { ARRAY } from '../../../common/utils/Utils'
import { useFormContext } from 'react-hook-form'

const MOCK_TAGS = [
  {
    name: 'Tag-01',
    apps: []
  },
  {
    name: 'Tag-02',
    apps: []
  },
  {
    name: 'Tag-03',
    apps: []
  },
  {
    name: 'Tag-04',
    apps: []
  },
  {
    name: 'Tag-05',
    apps: ['Cloud Management', 'Cloud Identity Engine', 'Cortex Data Lake']
  }
]

const Footer = ({ onSidecarClose }) => {
  const { formState } = useFormContext()
  const { isValid } = formState

  return (
    <div className='tw-flex tw-gap-2 tw-justify-end'>
      <Button appearance='secondary' onClick={onSidecarClose}>{BUTTON_CANCEL}</Button>
      <SubmitButton disabled={!isValid} appearance='primary'>{BUTTON_SAVE}</SubmitButton>
    </div>
  )
}

const ManageTags = ({ onSidecarClose }) => {

  const { openModal } = useModal(NewTagModal)

  const tags = useMemo(() => {
    return MOCK_TAGS.map((tag, index) => {
      return (
        <div key={index} className='tw-flex tw-w-full tw-justify-between'>
          <div className='tw-flex tw-w-1/2'>
            <div className='tw-flex tw-flex-1' style={{ alignItems: 'baseline' }}>
              <Checkbox
                name={tag.name}
                label={tag.name}
                showLabel={false}
                register={{
                  required: false
                }}
              />
              <TruncateText addClassName='tw-flex-1'>{tag.name}</TruncateText>
            </div>
            <div className='tw-flex tw-flex-col tw-flex-1'>
              {ARRAY.hasArray(tag.apps) ? (
                tag.apps.map((app, index) => <TruncateText key={index} truncate>{app}</TruncateText>)
              ) : <TruncateText truncate>{LABEL_NONE}</TruncateText>}
            </div>
          </div>
          <div className='tw-flex'>
            <Button appearance='tertiary-clear' aria-label='tag-trash' icon={<DeleteIcon size='sm' />}/>
            <Button appearance='tertiary-clear' aria-label='tag-edit' icon={<PencilIcon size='sm' />}/>
          </div>
        </div>
      )
    })
  }, [])

  return (
    <SheetBody>
      <Form mode='onBlur'>
        <div className='tw-flex tw-gap-2'>
          <SearchInput placeholder={'Search tags and apps'} addClassName='tw-flex-1'/>
          <Button appearance='secondary' onClick={() => openModal()}>{BUTTON_ADD_TAG}</Button>
        </div>
        <div className='tw-mt-4'>
          <div className='tw-flex tw-w-1/2'>
            <Body addClassName='tw-flex-1'>{COLUMN_TAGS}</Body>
            <Body addClassName='tw-flex-1'>{COLUMN_ASSOCIATED_APPS}</Body>
          </div>
          <hr/>
        </div>
        {tags}
        <hr/>
        <Footer {...{ onSidecarClose }} />
      </Form>
    </SheetBody>
  )
}

ManageTags.propTypes = {}
export default ManageTags
